// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1wZTz","title":"BackImages_title__1u2wH","images":"BackImages_images__17Bgb"};